import type { QuizScript } from '@quebon/shared-learning'

const CIRCLE_NUMBERS = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩']

// QuizScript 타입에는 없지만 inline 응답은 하위 문제(children)를 함께 내려준다.
export type AnswerKeyQuiz = Pick<QuizScript, 'type' | 'correctAnswers'> & {
  children?: Pick<QuizScript, 'type'>[] | null
}

function formatAnswers(type: string, correctAnswers: unknown[] | null | undefined): string {
  if (!correctAnswers || correctAnswers.length === 0) return '-'

  switch (type) {
    case 'multi_choice': {
      // correctAnswers는 인덱스(1-based) 또는 key
      return correctAnswers
        .map(a => {
          const idx = typeof a === 'number' ? a : parseInt(String(a), 10)
          if (!isNaN(idx) && idx >= 1 && idx <= CIRCLE_NUMBERS.length) {
            return CIRCLE_NUMBERS[idx - 1]
          }
          return String(a)
        })
        .join(', ')
    }
    case 'boolean':
      return String(correctAnswers[0]) === 'true' ? '맞아요' : '틀려요'
    case 'pairing':
    case 'image_select':
      return '해설참조'
    default:
      return correctAnswers.map(a => String(a)).join(', ')
  }
}

/**
 * 정답표에 표시할 정답 문자열.
 * inline은 correctAnswers가 하위 문제별 목록이므로 `(1) ①, ③ (2) ④`처럼 하위 문제 유형 형식으로 나눈다.
 */
export function getAnswerText(quiz: AnswerKeyQuiz): string {
  if (quiz.type !== 'inline') return formatAnswers(quiz.type, quiz.correctAnswers)

  const parts = quiz.correctAnswers ?? []
  if (parts.length === 0) return '-'
  return parts
    .map((answers, idx) => {
      const childType = quiz.children?.[idx]?.type ?? ''
      return `(${idx + 1}) ${formatAnswers(childType, Array.isArray(answers) ? answers : [answers])}`
    })
    .join(' ')
}
